import styled from 'styled-components'
import { Label } from 'reactstrap'
import colors from 'constants/colors'

const StyledLabel = styled(Label)`
  color: ${colors.inputLabelGrey};
  font-family: Poppins;
  font-weight: 600;
  font-size: 14px;
  display: block;
`

export default StyledLabel
